import { Directive, Injector, Input, OnInit, HostListener } from '@angular/core';
import { DiscussionEditorComponent } from '@farris/discussion-group';
import { ViewModel, UIStateObservableParam } from '@farris/devkit';
import { of, Observable, EMPTY } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
const KEY_UISTATE_REPLY_MESSAGE = 'DISCUSSION_REPLY_MESSAGE_INFO';
const KEY_MESSAGE_ON_COMMENT_ADD = 'onCommentAdd';

@Directive({
  selector: '[farris-discussion-editor-binding]'
})
export class FarrisDiscussionEditorBindingDirective implements OnInit {

  /**
   * è·åç¨æ·å½ä»¤
   */
  @Input("userQueryCommand") userQueryCommand: string;
  /**
   * æ·»å è¯è®ºå½ä»¤
   */
  @Input("addCommentCommand") addCommentCommand: string;
  /**
   * æ¥è¯¢ææé¨é¨å½ä»¤
   */
  @Input("queryAllOrgsCommand") queryAllOrgsCommand: string;
  /**
   * æ¥è¯¢å¸¸ç¨@ç¨æ·
   */
  @Input("queryFrequentAtUsersCommand") queryFrequentAtUsersCommand: string;

  constructor(public injector: Injector, public discussionEditorComponent: DiscussionEditorComponent, public viewModel: ViewModel) {
  }

  ngOnInit(): void {
    this.discussionEditorComponent.replyUser = this.viewModel.frameContext.root.viewModel.uiState[KEY_UISTATE_REPLY_MESSAGE] || {};
    this.viewModel.frameContext.root.viewModel.uiState.changes.subscribe((change: UIStateObservableParam) => {
      if (change.field === KEY_UISTATE_REPLY_MESSAGE) {
        this.discussionEditorComponent.replyUser = this.viewModel.frameContext.root.viewModel.uiState[KEY_UISTATE_REPLY_MESSAGE] || {};
      }
    });
    if (this.queryFrequentAtUsersCommand) {
      this.queryFrequentAtUsers();
    } else {
      this.queryAtUsers();
    }

    this.queryAllOrgs();
  }
  /**
   * æ¥è¯¢ææé¨é¨æ°æ®
   */
  private queryAllOrgs() {
    this.execute(this.queryAllOrgsCommand).subscribe(result => {
      if (!result) {
        return;
      }
      this.discussionEditorComponent.sectionData = result;
    });
  }
  /**
   * è·å@ç¨æ·
   */
  private queryAtUsers() {
    this.execute(this.userQueryCommand).subscribe(result => {
      if (!result) {
        return;
      }
      const { users = [] } = result;
      this.discussionEditorComponent.personnels = users;
    });
  }
  /**
   * è·åå¸¸ç¨@ç¨æ·
   */
  private queryFrequentAtUsers() {
    this.execute(this.queryFrequentAtUsersCommand).subscribe(result => {
      if (!result) {
        return;
      }
      this.discussionEditorComponent.personnels = result && result.users || [];
    });
  }
  /**
   * æäº¤æåæ¶è¯è®º
   * @param event event
   */
  @HostListener('valueChange', ['$event'])
  public pageChangedHandler(event: any) {
    const { msgInfo = 0, text = '', visibility = 'ALL', parentId = null } = event || {};
    if (msgInfo === 1) {
      this.execute(this.addCommentCommand, { text, parentId, visibility }).pipe(
        tap(() => {
          this.viewModel.frameContext.appContext.messagePipe.next(KEY_MESSAGE_ON_COMMENT_ADD);
        }),
        catchError(e => EMPTY)
      ).subscribe();
    } else {
      // åæ¶çæ¶ååæ¶ä¼å°åå¤ç¨æ·æ¸ç©º
      this.viewModel.frameContext.root.viewModel.uiState[KEY_UISTATE_REPLY_MESSAGE] = {};
      this.discussionEditorComponent.replyUser = {};
    }
  }
  /**
   * æ§è¡å½ä»¤
   * @param commandName å½ä»¤åç§°
   */
  private execute(commandName: string, params?: any): Observable<any> {
    if (!commandName || commandName === '' || commandName === 'undefined') {
      return of(null);
    }
    if (typeof params === 'undefined') {
      params = {};
    }
    const paths = commandName.split('.');
    let func = null;
    paths.forEach(path => {
      func = func && func[path] || this[path];
    });
    if (typeof func === 'function') {
      return func(params);
    }
    return of(null);
  }
}
